<template>
  <div class="service-edit-page w-100">
    <!-- Header Section -->
    <div class="w-100 px-8 py-4 bg-white border-bottom">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <b-button variant="light" class="mr-4 btn btn-secondary" @click="goBack">
            <i class="ki ki-arrow-left icon-sm"></i>
            Quay lại
          </b-button>
        </div>
        <div>
          <b-button variant="secondary" class="mr-2" @click="goBack">
            Hủy
          </b-button>
          <loading-button
            :handler="handleValidate"
            class="btn btn-success"
          >
            {{ isCreateForm ? 'Thêm mới' : 'Cập nhật' }}
          </loading-button>
        </div>
      </div>
    </div>

    <!-- Form Content -->
    <b-overlay :show="loading">
      <div class="container-fluid py-6">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <b-card no-body class="shadow-sm">
              <div class="card-body p-6">
                <service-form
                  ref="serviceForm"
                  v-model="form"
                />
              </div>
            </b-card>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ServiceForm from './modal/ServiceForm.vue';
import { SERVICE_CATEGORY_OPTIONS } from '../constants/clinicBundleConstants';

export default {
  name: 'ServiceEdit',
  components: {
    'service-form': ServiceForm,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    form_type: {
      type: String,
      default: 'edit',
    },
    itemData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        id: null,
        name: '',
        category: null,
        price: null,
        minutes: null,
        serviceProviderId: null,
        description: '',
        status: 0,
        appFeature: 0,
        reportType: null,
        bundleTagId: null,
        specialtyId: null,
        specialtyName: null,
        clinicId: null,
        benefitTypeId: null,
      },
    };
  },

  computed: {
    isCreateForm() {
      return !this.id;
    },
  },

  created() {
    if (this.itemData) {
      this.form = {
        id: this.itemData.id,
        name: this.itemData.name || '',
        category: this.mapCategory(this.itemData.category),
        price: this.itemData.price || null,
        minutes: this.itemData.minutes || null,
        serviceProviderId: this.itemData.serviceProviderId || null,
        description: this.itemData.description || '',
        status: this.itemData.status !== undefined ? this.itemData.status : 0,
        appFeature: this.itemData.appFeature !== undefined ? this.itemData.appFeature : 0,
        reportType: this.itemData.reportType || null,
        bundleTagId: this.itemData.bundleTagId || null,
        specialtyId: this.itemData.specialtyId || null,
        specialtyName: this.itemData.specialtyName || null,
        clinicId: this.itemData.clinicId || null,
        benefitTypeId: this.itemData.bundleBenefitTypeId || null,
      };
    } else {
      this.loadData();
    }
  },

  methods: {
    async loadData() {
      if (!this.id) return;
      try {
        this.loading = true;
        const { data } = await this.$api.get(`BundleService/${this.id}`);
        this.form = {
          id: data.id,
          name: data.name || '',
          category: this.mapCategory(data.category),
          price: data.price || null,
          minutes: data.minutes || null,
          serviceProviderId: data.serviceProviderId || null,
          description: data.description || '',
          status: data.status !== undefined ? data.status : 0,
          appFeature: data.appFeature !== undefined ? data.appFeature : 0,
          reportType: data.reportType || null,
          bundleTagId: data.bundleTagId || null,
          specialtyId: data.specialtyId || null,
          specialtyName: data.specialtyName || null,
          clinicId: data.clinicId || null,
          benefitTypeId: data.bundleBenefitTypeId || null,
        };
      } catch (error) {
        this.$toastr.e({ title: 'Lỗi!', msg: error });
        this.goBack();
      } finally {
        this.loading = false;
      }
    },

    async handleValidate() {
      let isValid = true;
      try {
        isValid = await this.$refs.serviceForm.validate();
      } catch (e) {
        console.error('Validate error:', e);
      }
      if (!isValid) {
        this.$toastr.e({ title: 'Lỗi!', msg: 'Vui lòng điền đầy đủ thông tin bắt buộc!' });
        return;
      }
      await this.submit();
    },

    mapCategory(categoryId) {
      if (categoryId == null) return null;
      const found = SERVICE_CATEGORY_OPTIONS.find(opt => opt.value === Number(categoryId));
      return found ? { value: found.value, text: found.text } : null;
    },

    async submit() {
      const payload = new FormData();
      payload.append('name', this.form.name || '');
      payload.append('category', 0);

      payload.append('price', parseInt(this.form.price) || 0);
      payload.append('minutes', parseInt(this.form.minutes) || 0);
      payload.append('serviceProviderId', this.form.serviceProviderId || '');
      payload.append('description', this.form.description || '');
      payload.append('status', parseInt(this.form.status) || 0);
      payload.append('appFeature', parseInt(this.form.appFeature) || 0);
      if (this.form.reportType) payload.append('reportType', this.form.reportType);
      if (this.form.bundleTagId) payload.append('bundleTagId', this.form.bundleTagId);
      if (this.form.specialtyId != null) payload.append('specialtyId', this.form.specialtyId);
      if (this.form.specialtyName) payload.append('specialtyName', this.form.specialtyName);
      if (this.form.clinicId != null) payload.append('clinicId', this.form.clinicId);
      if (this.form.benefitTypeId) payload.append('bundleBenefitTypeId', this.form.benefitTypeId);

      try {
        this.loading = true;
        if (this.isCreateForm) {
          await this.$api.post('BundleService', payload);
          this.$toastr.s({ title: 'Thành công!', msg: 'Thêm mới thành công!' });
        } else {
          payload.append('id', this.form.id);
          await this.$api.put(`BundleService/${this.form.id}`, payload);
          this.$toastr.s({ title: 'Thành công!', msg: 'Cập nhật thành công!' });
        }
        this.goBack();
      } catch (error) {
        this.$toastr.e({ title: 'Lỗi!', msg: error });
      } finally {
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: 'services_products' });
    },
  },
};
</script>

<style scoped lang="scss">
.service-edit-page {
  background-color: #f8f9fa;
  min-height: 100vh;
}
</style>